"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnanchoredTransactionListResponseToJSON = exports.UnanchoredTransactionListResponseFromJSONTyped = exports.UnanchoredTransactionListResponseFromJSON = void 0;
function UnanchoredTransactionListResponseFromJSON(json) {
    return UnanchoredTransactionListResponseFromJSONTyped(json, false);
}
exports.UnanchoredTransactionListResponseFromJSON = UnanchoredTransactionListResponseFromJSON;
function UnanchoredTransactionListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'total': json['total'],
        'results': json['results'],
    };
}
exports.UnanchoredTransactionListResponseFromJSONTyped = UnanchoredTransactionListResponseFromJSONTyped;
function UnanchoredTransactionListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total': value.total,
        'results': value.results,
    };
}
exports.UnanchoredTransactionListResponseToJSON = UnanchoredTransactionListResponseToJSON;
//# sourceMappingURL=UnanchoredTransactionListResponse.js.map